export const modals = {
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  CANCELLATION_POLICY: 'CANCELLATION_POLICY',
  M2PAY_3DS: 'M2PAY_3DS',
  SAFERPAY_3DS: 'SAFERPAY_3DS'
}
